// Regional adapter: app-core owns the native transport contract.
export * from "@catchy/app-core/src/nativeStorageBridge";
